(() => {
  'use strict';
  const el = document.querySelector('[data-bbb-peek]');
  if (!el || el.dataset.ready) return;
  el.dataset.ready = 'true';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const key = 'bbb-peek-session-v1';
  const now = Date.now();
  let state = { count: 0, last: 0, activity: now };
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (saved && now - saved.activity < 1800000) state = saved;
  } catch (_) { return; } // No persistence: keep the decoration off rather than repeat it.
  let shownOnPage = false, visible = false, loading = false, frame = 0, timer = 0;
  let lastCheck = 0, settle = 0;
  function targetRect() {
    const top=parseFloat(el.style.top)||0, width=el.offsetWidth;
    const left=el.dataset.side==='right'?document.documentElement.clientWidth-width:0;
    return {top,bottom:top+el.offsetHeight,left,right:left+width};
  }
  const image = el.querySelector('img');
  const start = performance.now();
  const threshold = 300 + Math.random() * 250;
  const blocked = () => document.hidden || motion.matches ||
    document.querySelector('dialog[open],.drawer--is-open,.modal--is-active,.rps-overlay-open') ||
    document.documentElement.classList.contains('bbb-menu-lock') ||
    /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName);
  function hide() {
    el.classList.remove('is-visible');
    visible = false;
    clearTimeout(timer);
  }
  function safe(rect) {
    if (rect.top < 170 || rect.bottom > innerHeight - 160) return false;
    const nodes = document.querySelectorAll('main a,main button,main input,main select,main textarea,main img,main video,main h1,main h2,main h3,main p,main [class*="price"],footer a,footer button,footer input,footer p,footer h2,footer h3,footer img,.collection-filter,.bbb-choices');
    return !Array.from(nodes).some(node => {
      let b = node.getBoundingClientRect();
      if (/^H[1-3]$|^P$/.test(node.tagName)) { const range = document.createRange(); range.selectNodeContents(node); b = range.getBoundingClientRect(); }
      return b.width && b.height && b.left < rect.right + 5 && b.right > rect.left - 5 &&
        b.top < rect.bottom + 5 && b.bottom > rect.top - 5;
    });
  }
  function findSpot() {
    const w = el.offsetWidth, h = el.offsetHeight;
    const sides = Math.random() < .5 ? ['left','right'] : ['right','left'];
    const tops = Array.from(document.querySelectorAll('main .shopify-section,main .grid-product,footer')).flatMap(n => { const top=n.getBoundingClientRect().top; return [top-h-8,top+12]; });
    // Try only section/row boundaries, never arbitrary product positions.
    for (const side of sides) {
      for (const top of tops) {
        const left = side === 'left' ? 0 : document.documentElement.clientWidth - w;
        const rect = {top,bottom:top+h,left,right:left+w};
        if (safe(rect)) return {side,top};
      }
    }
    return null;
  }
  function check() {
    frame = 0;
    if (visible) {
      if (blocked() || !safe(targetRect())) hide();
      return;
    }
    if (loading || shownOnPage || state.count >= 2 || blocked() ||
        scrollY < threshold || performance.now() - start < 2500 ||
        Date.now() - state.last < 60000 || performance.now() - lastCheck < 250) return;
    lastCheck = performance.now();
    const spot = findSpot();
    if (!spot) return;
    loading = true;
    image.onload = () => {
      loading = false;
      const current = findSpot();
      if (!current || blocked() || shownOnPage) return;
      el.dataset.side = spot.side;
      el.style.top = current.top + 'px';
      // Recheck the actual side after the image has loaded.
      if (!safe({top:current.top,bottom:current.top+el.offsetHeight,
        left:spot.side==='left'?0:document.documentElement.clientWidth-el.offsetWidth,
        right:spot.side==='left'?el.offsetWidth:document.documentElement.clientWidth})) return;
      state = {count:state.count+1,last:Date.now(),activity:Date.now()};
      try { sessionStorage.setItem(key, JSON.stringify(state)); } catch (_) { return; }
      shownOnPage = true;
      visible = true;
      el.classList.add('is-visible');
      timer = setTimeout(hide, 3000);
    };
    image.onerror = () => { loading = false; shownOnPage = true; };
    image.src = el.dataset[spot.side];
  }
  addEventListener('scroll', () => {
    if (visible && (blocked() || !safe(targetRect()))) hide();
    clearTimeout(settle);
    settle = setTimeout(() => { if (!frame) frame=requestAnimationFrame(check); }, 220);
  }, {passive:true});
  addEventListener('resize',hide,{passive:true});
  document.addEventListener('visibilitychange',hide);
  document.addEventListener('pointerdown',hide,{passive:true});
  motion.addEventListener('change',hide);
})();
